export enum CarrierType {
    NewPost = 1,
    MeestExpress,
    AddressDelivery,
    PickUp,
    Delivery,
    DPD,
    Raben,
    Other = 100
}